<template>
    <Modal id="addressChioce" v-model="invoiceMdl" width="640" class-name="vertical-center-modal no-padding">
        <div class="close-btn" slot="close">
            <i class="iconfont icon-pop-close"></i>
        </div>

        <div slot="header">
            <div class="title">实名认证</div>
        </div>

        <div class="invoice-form">
            <div class="mainInvoicePage">
                <div class="mainInvoice">
                    <div class="item">
                        <span class="label">
                            <span class="red-font">*</span>选择账号类型: </span>
                        <div style="display:inline-block">
                            <div class="type-tabs">
                                <span :class="{'active':titleType}" @click="changeTitle(true)">个人</span>
                                <span :class="{'active':!titleType}" @click="changeTitle(false)">企业</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="realNameMain" v-if="titleType">
                    <div class="item name">
                        <div class="left">
                            <span class="text">
                                <span>*</span>真实姓名：</span>
                        </div>
                        <div class="input1">
                            <input @blur="checkInput('name')" style="width: 310px;" type="text" v-model="user.realName">
                            <i class="iconfont icon-close" v-if="user.realName" @click="clear($event,'realName')"></i>
                        </div>
                        <span class="errorMsg">{{errorMsg.realName}}</span>
                    </div>
                    <div class="item phone">
                        <div class="left">
                            <span class="text">
                                <span>*</span>身份证号：</span>
                        </div>
                        <div class="input1">
                            <input @blur="checkInput('id')" style="width: 271px;" type="text" v-model="user.identityNumber">
                            <i class="iconfont icon-close" v-if="user.identityNumber" @click="clear($event,'identityNumber')"></i>
                        </div>
                        <span class="errorMsg">{{errorMsg.identityNumber}}</span>
                    </div>

                    <div class="item">
                        <div class="left">
                            <span class="text">
                                <span>*</span>电话号码：</span>
                        </div>
                        <div class="input1">
                            <input @blur="checkInput('phone', false)" type="text" v-model="user.phone">
                            <i class="iconfont icon-close" v-if="user.phone" @click="clear($event,'phone')"></i>
                        </div>
                        <div class="code">
                            <div class="input1">
                                <input style="padding: 3px 5px;background: #EBEFF0;color: #555555;" @blur="checkInput('code', false)" type="text" v-model="user.code" placeholder="请输入验证码">
                                <span class="disableSpan" v-if="timer > 0">{{timer}}s后发送</span>
                                <span v-else @click="getCode">点击发送</span>
                            </div>
                        </div>
                        <span class="errorMsg">{{errorMsg.phone}}</span>
                        <span class="errorMsg" v-if="!errorMsg.phone">{{errorMsg.code}}</span>
                    </div>
                </div>

                <div class="realNameMain" v-else>
                    <div class="item name">
                        <div class="left">
                            <span class="text">
                                <span>*</span>公司名称：</span>
                        </div>
                        <div class="input1">
                            <input @blur="checkInputCompany('companyName', false)" style="width: 301px;" type="text" v-model="companyUser.companyName">
                            <i class="iconfont icon-close" v-if="companyUser.companyName" @click="clear($event,'companyName')"></i>
                        </div>
                        <span class="errorMsg">{{companyErrorMsg.companyName}}</span>
                    </div>

                    <div class="item name">
                        <div class="left">
                            <span class="text">
                                <span>*</span>营业执照注册号：</span>
                        </div>
                        <div class="input1">
                            <input @blur="checkInputCompany('regCode', false)" style="width: 271px;" type="text" v-model="companyUser.regCode">
                            <i class="iconfont icon-close" v-if="companyUser.regCode" @click="clear($event,'regCode')"></i>
                        </div>
                        <span class="errorMsg">{{companyErrorMsg.regCode}}</span>
                    </div>

                    <div class="item name">
                        <div class="left">
                            <span class="text">
                                <span>*</span>法人真实姓名：</span>
                        </div>
                        <div class="input1">
                            <input @blur="checkInputCompany('legalPerson', false)" style="width: 301px;" type="text" v-model="companyUser.legalPerson">
                            <i class="iconfont icon-close" v-if="companyUser.legalPerson" @click="clear($event,'legalPerson')"></i>
                        </div>
                        <span class="errorMsg">{{companyErrorMsg.legalPerson}}</span>
                    </div>

                    <div class="item name">
                        <div class="left">
                            <span class="text">
                                <span>*</span>法人身份证号：</span>
                        </div>
                        <div class="input1">
                            <input @blur="checkInputCompany('legalPersonIdentityCard', false)" style="width: 271px;" type="text" v-model="companyUser.legalPersonIdentityCard">
                            <i class="iconfont icon-close" v-if="companyUser.legalPersonIdentityCard" @click="clear($event,'legalPersonIdentityCard')"></i>
                        </div>
                        <span class="errorMsg">{{companyErrorMsg.legalPersonIdentityCard}}</span>
                    </div>

                    <div class="item">
                        <div class="left">
                            <span class="text">
                                <span>*</span>手机号：</span>
                        </div>
                        <div class="input1">
                            <input @blur="checkInputCompany('legalPersonMobilePhone', false)" type="text" style="width: 158px;" v-model="companyUser.legalPersonMobilePhone">
                            <i class="iconfont icon-close" v-if="companyUser.legalPersonMobilePhone" @click="clear($event,'legalPersonMobilePhone')"></i>
                        </div>
                        <span class="errorMsg">{{companyErrorMsg.legalPersonMobilePhone}}</span>
                    </div>

                </div>

                <div class="oper-btn" style="padding-top: 30px;">
                    <!--<button class="cancel-btn " @click="invoiceMdl = false">取消</button>-->
                    <button :disabled="buttonDisabled" class="main-btn" @click="invoiceSave">确定</button>
                </div>
            </div>

            <Modal v-model="imgValidator" class="imgValidator" width="360">
                <div class="close-btn" slot="close">
                    <i class="iconfont icon-pop-close"></i>
                </div>
                <div slot="header" class="title">请输入验证码</div>
                <img-validate ref="imgValidator" :phone="user.phone" @sendMsg="sendMsgBegin"></img-validate>
            </Modal>
            <delete-confirm id="message" ref="deleteConfirm"></delete-confirm>
        </div>
    </Modal>
</template>
<script>
import api from '../../api'
import util from '../../libs/util';
import imgValidate from '../pages/account/imgValidateModal.vue';
import validator from '../pages/account/validator';
import deleteConfirm from './deleteConfirm.vue'
const reg_phone = validator.reg_phone;
export default {
    data () {
        return {
            invoiceMdl: false,
            titleType: true,//true:personal false:company

            user: {
                realName: '',
                phone: '',
                code: '',
                identityNumber: '',
            },
            errorMsg: {
                realName: '',
                phone: '',
                code: '',
                identityNumber: '',
            },
            timer: 0,
            imgValidator: false,

            companyUser: {
                companyName: '',
                legalPerson: '',
                legalPersonIdentityCard: '',
                legalPersonMobilePhone: '',
                regCode: ''
            },
            companyErrorMsg: {
                companyName: '',
                legalPerson: '',
                legalPersonIdentityCard: '',
                legalPersonMobilePhone: '',
                regCode: ''
            },
            buttonDisabled: false
        };
    },
    components: {
        imgValidate, deleteConfirm
    },
    methods: {
        open () {
            this.invoiceMdl = true;
        },
        changeTitle (bollean) {
            this.titleType = bollean
        },
        invoiceSave () {
            if (this.titleType) {
                if (!this.validatePerson('nothing', true)) {
                    return
                }
                this.buttonDisabled = true;
                api.account.real_name_auth(this.user)
                    .then(res => {
                        if (res) {
                            this.invoiceMdl = false;
                            this.$Message.success('实名认证成功！')
                            this.$emit('getPutOrder')
                            this.buttonDisabled = false;
                        } else {
                            this.$refs.deleteConfirm.open({
                                text: '认证失败，请填写正确信息',
                                bigButton: true
                            })
                            this.buttonDisabled = false;
                        }
                    }).catch((err) => {
                        this.$refs.deleteConfirm.open({
                            text: err.data.message || '服务器出错！请稍后重试！',
                            bigButton: true
                        })
                        this.buttonDisabled = false;
                    })
            } else {
                if (!this.validate('nothing', true)) {
                    return
                }
                this.buttonDisabled = true;
                api.account.company_real_name_auth(this.companyUser)
                    .then(res => {
                        if (res) {
                            this.invoiceMdl = false;
                            this.$Message.success('企业实名认证成功！')
                            this.$emit('getPutOrder')
                            this.buttonDisabled = false;
                        } else {
                            this.$refs.deleteConfirm.open({
                                text: '企业认证失败，请填写正确信息',
                                bigButton: true
                            })
                            this.buttonDisabled = false;
                        }
                    }).catch((err) => {
                        this.$refs.deleteConfirm.open({
                            text: err.data.message || '服务器出错！请稍后重试！',
                            bigButton: true
                        })
                        this.buttonDisabled = false;
                    })
            }
        },
        getPrice () {
            const { pricePay } = AppBase.session;
            //                this.invoice.invoicePrice = pricePay;
            if (this.invoicePriceTotal) {
                this.invoicePriceData = this.invoicePriceTotal;
                this.invoice.invoicePrice = this.invoicePriceTotal;
            } else {
                this.invoicePriceData = pricePay;
                this.invoice.invoicePrice = pricePay;
            }
        },

        closeImgValidator () {
            this.imgValidator = false;
        },
        sendMsgBegin () {
            this.closeImgValidator();
            let that = this;
            this.timer = parseInt(util.getCookie('authenticationCountDown')) || 90
            that.timerInterval = setInterval(function () {
                that.timer--;
                util.setCookie('authenticationCountDown', that.timer);
                if (that.timer == 0) {
                    util.setCookie('authenticationCountDown', "", -1)
                    clearInterval(that.timerInterval);
                }
            }, 1000);
        },

        clear (e, key) {
            e.target.previousElementSibling.focus();
            this.user[key] = '';
        },

        getCode () {
            if (this.user.phone) {
                if (!reg_phone.test(this.user.phone)) {
                    this.errorMsg.phone = '您输入的手机号不符合规则';
                    return;
                } else {
                    api.account.checkPhoneExist({
                        phone: this.user.phone
                    })
                        .then((res) => {
                            if (res) {
                                this.$refs.imgValidator.open('realName');
                                this.imgValidator = true;
                            }
                        });
                }
            } else {
                this.errorMsg.phone = '手机号必填';
            }
        },
        checkInput (check) {
            this.validatePerson(check, false);
        },
        checkInputCompany (check) {
            this.validate(check, false);
        },

        validatePerson (check, nomal) {
            if (check === 'name' || nomal) {
                if (!this.user.realName) {
                    this.errorMsg.realName = '请输入您的真实姓名';
                    if (nomal) {
                        this.$Message.error('请输入您的真实姓名')
                    }
                    return false;
                } else {
                    this.errorMsg.realName = '';
                }
            }

            if (check === 'id' || nomal) {
                if (!this.user.identityNumber) {
                    this.errorMsg.identityNumber = '请输入您的身份证账号';
                    if (nomal) {
                        this.$Message.error('请输入您的身份证账号')
                    }
                    return false;
                } else if (!validator.checkCard(this.user.identityNumber)) {
                    this.errorMsg.identityNumber = '您的身份证账号不合法';
                    if (nomal) {
                        this.$Message.error('您的身份证账号不合法');
                    }
                    return false;
                } else {
                    this.errorMsg.identityNumber = '';
                }
            }

            if (check === 'phone' || nomal) {
                if (!this.user.phone) {
                    this.errorMsg.phone = '请输入您的手机号码';
                    if (nomal) {
                        this.$Message.error('请输入您的手机号码')
                    }
                    return false;
                } else if (!reg_phone.test(this.user.phone)) {
                    this.errorMsg.phone = '您的手机号码不合法';
                    if (nomal) {
                        this.$Message.error('您的手机号码不合法')
                    }
                    return false;
                } else {
                    this.errorMsg.phone = '';
                }
            }

            if (check === 'code' || nomal) {
                if (!this.user.code) {
                    this.errorMsg.code = '请输入验证码 ';
                    if (nomal) {
                        this.$Message.error('请输入验证码')
                    }
                    return false;
                } else {
                    this.errorMsg.code = '';
                }
            }

            return true;
        },

        validate (check, nomal) {
            if (check === 'companyName' || nomal) {
                if (!this.companyUser.companyName) {
                    this.companyErrorMsg.companyName = '请输入公司名称';
                    if (nomal) {
                        this.$Message.error('请输入公司名称')
                    }
                    return false;
                } else {
                    this.companyErrorMsg.companyName = '';
                }
            }

            if (check === 'regCode' || nomal) {
                if (!this.companyUser.regCode) {
                    this.companyErrorMsg.regCode = '请输入营业执照注册号';
                    if (nomal) {
                        this.$Message.error('请输入营业执照注册号')
                    }
                    return false;
                } else {
                    this.companyErrorMsg.regCode = '';
                }
            }

            if (check === 'legalPerson' || nomal) {
                if (!this.companyUser.legalPerson) {
                    this.companyErrorMsg.legalPerson = '请输入法人姓名 ';
                    if (nomal) {
                        this.$Message.error('请输入法人姓名');
                    }
                    return false;
                } else {
                    this.companyErrorMsg.legalPerson = '';
                }
            }

            if (check === 'legalPersonIdentityCard' || nomal) {
                if (!this.companyUser.legalPersonIdentityCard) {
                    this.companyErrorMsg.legalPersonIdentityCard = '请输入您的身份证账号';
                    if (nomal) {
                        this.$Message.error('请输入您的身份证账号')
                    }
                    return false;
                } else if (!validator.checkCard(this.companyUser.legalPersonIdentityCard)) {
                    this.companyErrorMsg.legalPersonIdentityCard = '您的身份证账号不合法';
                    if (nomal) {
                        this.$Message.error('您的身份证账号不合法');
                    }
                    return false;
                } else {
                    this.errorMsg.legalPersonIdentityCard = '';
                }
            }

            if (check === 'legalPersonMobilePhone' || nomal) {
                if (!this.companyUser.legalPersonMobilePhone) {
                    this.companyErrorMsg.legalPersonMobilePhone = '请输入法人手机号';
                    if (nomal) {
                        this.$Message.error('请输入法人手机号')
                    }
                    return false;
                } else if (!reg_phone.test(this.companyUser.legalPersonMobilePhone)) {
                    if (nomal) {
                        this.companyErrorMsg.legalPersonMobilePhone = '您的手机号码不合法';
                    }
                    this.$Message.error('您的手机号码不合法')
                    return false;
                } else {
                    this.companyErrorMsg.legalPersonMobilePhone = '';
                }
            }
            return true;
        },

    },
    created () {

    },
    watch: {}
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.invoice-form {
  padding: 34px 30px;
}

.invoice-form .item {
  text-align: left;
  margin-bottom: 0px !important;
}

.invoice-form .item .label {
  color: #171a1a;
  line-height: 17px;
  letter-spacing: 2px;
  display: inline-block;
  margin-right: 10px;
  vertical-align: top;
}

.invoice-form .item .chioceButton {
  width: 100px;
  height: 32px;
  background: #99c72c;
  border-radius: 4px;
  line-height: 32px;
  text-align: center;
  font-size: 12px;
  color: #ffffff;
}

.invoice-form .item .chioceButton:hover {
  opacity: 0.8;
}

.invoice-form .item .value {
  color: #6c6f70;
}

.invoice-form .item .value.money {
  color: #171a1a;
}

.invoice-form .item .input input {
  border: 1px solid #ebeff0;
  border-radius: 4px;
  height: 40px;
  padding: 0 16px;
  width: 100%;
}

.invoice-form .item .input {
  position: relative;
  display: inline-block;
  width: 300px;
}

.invoice-form .item .input .icon-close {
  color: #a2a2a8;
  font-size: 12px;
  position: absolute;
  right: 20px;
  top: 8px;
}

.invoice-form .item .type-tabs {
  margin-bottom: 8px;
}

.invoice-form .item .type-tabs span {
  display: inline-block;
  width: 34px;
  cursor: pointer;
}

.invoice-form .item .type-tabs span:first-child {
  margin-right: 16px;
}

.invoice-form .item .type-tabs span.active {
  color: #308697;
  border-bottom: 1px solid #308697;
  text-align: center;
}

.invoice-form .invoice-state {
  font-size: 12px;
  color: #a2a2a8;
  text-align: left;
  margin-bottom: 48px;
  margin-top: 8px;
}

.invoice-form .invoice-state span {
  display: inline-block;
  vertical-align: top;
  margin-right: 16px;
}

.invoice-form .invoice-state div {
  display: inline-block;
}

.invoice-form .oper-btn button:first-child {
  margin-right: 16px;
  width: 100px;
  text-align: center;
}

.invoice-form .oper-btn button:disabled {
  background: rgb(235, 239, 240);
}

#addressChioce .mainInvoicePage .mainInvoice {
  height: auto !important;
  overflow: auto;
  padding: 10px 0;
}

.realNameMain {
  .item {
    margin-top: 15px;
    text-align: left;

    .left {
      display: inline-block;
      /*width: 150px;*/
      margin-right: 10px;
      vertical-align: middle;

      .text {
        float: right;
        margin-right: 10px;

        > span {
          color: #e14b5d;
        }
      }
    }
    .input1 {
      display: inline-block;
      vertical-align: middle;
      position: relative;

      > i {
        position: absolute;
        right: 5px;
        top: 7px;
        font-size: 12px;
        cursor: pointer;
        color: rgba(0, 0, 0, 0.65);
      }

      input {
        width: 148px;
        background: #ffffff;
        border: 1px solid #ebeff0;
        border-radius: 4px;
        height: 30px;
        padding: 3px 22px 3px 15px;
      }
    }
    .errorMsg {
      font-size: 12px;
      color: #e14b5d;
      margin-left: 10px;
    }

    .code {
      display: inline-block;
      vertical-align: middle;
      margin-left: 5px;

      .input1 {
        input {
          width: 112px;
        }

        > span {
          display: inline-block;
          vertical-align: middle;
          padding: 6px 15px;
          background: #99c72c;
          border-radius: 4px;
          font-size: 12px;
          color: #ffffff;
          margin-left: 9px;
          cursor: pointer;
        }

        .disableSpan {
          background: #999;
          cursor: default;
        }
      }
    }
    .errorAddressMsg {
      display: inline-block;
      vertical-align: middle;
      font-size: 12px;
      color: #e14b5d;
    }

    .addressMsg {
      display: inline-block;
      vertical-align: middle;
      font-size: 12px;

      > input {
        width: 500px;
      }
    }
    .input2 {
      display: inline-block;
      vertical-align: middle;
      position: relative;

      .errorMsg {
        position: absolute;
        font-size: 12px;
        color: #e14b5d;
        left: 0px;
        top: -20px;
      }

      .provice {
        display: inline-block;
        width: 90px;
        height: 28px;
        vertical-align: middle;
      }

      #city {
        display: inline-block;
        vertical-align: middle;
        width: 200px;
        height: 28px;

        > span {
          font-size: 12px;
          float: left;
          color: #555555;
          margin-left: 36px;
          vertical-align: middle;
          margin-right: 20px;
          margin-top: 6px;
        }

        .ivu-select {
          float: left;
          width: 90px;
          vertical-align: middle;
          border: none;
          background: #ebeff0;
        }
      }
    }
    #input2 {
      .ivu-select-selected-value,
      .ivu-select-placeholder {
        background: #ebeff0;
        border: none;
      }

      .ivu-select-selection {
        background: #ebeff0;
        border: none;
      }

      .page .ivu-select .ivu-select-selection {
        border: none;
        border-radius: 4px;
      }
    }
    .input3 {
      display: inline-block;
      vertical-align: middle;
      position: relative;

      .errorMsg {
        position: absolute;
        font-size: 12px;
        color: #e14b5d;
        left: 0px;
        top: -20px;
      }

      > i {
        position: absolute;
        right: 5px;
        top: 7px;
        font-size: 12px;
        cursor: pointer;
        color: rgba(0, 0, 0, 0.65);
      }

      input {
        width: 420px;
        background: #ebeff0;
        border-radius: 4px;
        height: 30px;
        padding: 3px 15px;
      }
    }
    .detailAddressCC {
      vertical-align: top;

      textarea {
        width: 420px;
        background: #ebeff0;
        border-radius: 4px;
        height: 64px;
        padding: 3px 15px;
        vertical-align: top;
        border: none;
      }
    }
    .input4,
    .input5 {
      display: inline-block;
      vertical-align: top;

      .left,
      .right {
        cursor: pointer;
        display: inline-block;
        vertical-align: top;
        width: 360px;
        text-align: center;
        height: 250px;
        /*line-height: 250px;*/
        background: #ebeff0;
        border: 2px dashed #c8cccc;
        border-radius: 4px;
        margin-bottom: 20px;

        .preview {
          width: 356px;
          height: 246px;
          overflow: hidden;
          text-align: center;

          img {
            display: inline-block;
            height: 100%;
          }
        }
        .preview-small {
          width: 320px;
          height: 218px;
        }

        .loading {
          display: inline-block;
          height: 50px;
          width: 50px;
          margin-top: 100px;
        }

        i {
          display: inline-block;
          margin-top: 70px;
          font-size: 38px;
          color: #a2a2a8;
        }

        p {
          text-align: center;
          font-size: 14px;
          color: #6c6f70;
          margin-top: 9px;
        }
      }
      .left-small,
      .right-small {
        width: 320px;
        height: 222px;
      }

      .right {
        margin-left: 40px;
      }

      .exImg {
        border: none;
        background: #fff;

        img {
          display: inline-block;
          height: 100%;
          margin-left: 30px;
        }

        > span {
          font-size: 12px;
          color: #555555;
          position: absolute;
          left: 0px;
          top: 0px;
        }
      }
    }
    .input5 {
      display: inline-block;
      width: 765px;

      .left,
      .right {
        position: relative;

        .titleDesc {
          position: absolute;
          font-size: 14px;
          color: #353838;
          top: 20px;
          left: 20px;
        }
      }
    }
  }
}
</style>
<style>
#message .ivu-modal-mask {
  z-index: 1200;
}

#message .ivu-modal-wrap {
  z-index: 1300;
}
</style>